export function validSize(size) {
    return ['s', 'm', 'l'].includes(size);
}
export function validType(type) {
    return ['primary', 'secondary', 'tertiary'].includes(type);
}
export function validIconButtonType(type) {
    return ['primary', 'secondary', 'tertiary', 'overlay'].includes(type);
}
export function validVariant(shape) {
    return ['basic', 'icon', 'home'].includes(shape);
}
export function filterOtherNativeProps(props) {
    const keys = Object.keys(props);
    const nativeProps = {};
    keys.forEach((k) => {
        const key = k.toLowerCase();
        if (key.startsWith('aria-') ||
            key.startsWith('data-') ||
            key.startsWith('on') ||
            ['id', 'title', 'role', 'tabindex'].includes(key)) {
            nativeProps[k] = props[k];
        }
        else if (typeof props.href === 'string' &&
            ['href', 'target', 'download'].includes(key)) {
            nativeProps[k] = props[k];
        }
    });
    return nativeProps;
}
